import React from 'react';
import Bascket from "./DeliveryInterface/Bascket";

import '../css/DeliveryStyles.css';
import '../css/Bascket.css';

const Delivery = ({ handleXBarItemChange, onBackToMenu }) => {
    return (
        <div style={{ background: '#000', minHeight: '100vh', paddingTop: 56 }}>
            <Bascket handleXBarItemChange={handleXBarItemChange} onBackToMenu={onBackToMenu}/>
        </div>
    );
};

export default Delivery;